import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DireccionAdministrativaService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getDireccionAdministrativa(): Observable<any> {
    return this.http.get(this.baseUrl + 'parDireccionAdministrativa', { headers: this.header(this.token) });
  }

  getDireccionAdministrativaActivo(): Observable<any> {
    return this.http.get(this.baseUrl + 'parDireccionAdministrativaActivos', { headers: this.header(this.token) });
  }
  
  getDireccionAdministrativaById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parDireccionAdministrativa/' + id, { headers: this.header(this.token) });
  }

  postDireccionAdministrativa(DireccionAdministrativa: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parDireccionAdministrativa', DireccionAdministrativa, { headers: this.header(this.token) });
  }

  putDireccionAdministrativa(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parDireccionAdministrativa', bodyString, { headers: this.header(this.token) });
  }

  deleteDireccionAdministrativa(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parDireccionAdministrativa/' + id, { headers: this.header(this.token) });
  }
  
}